// extracted by mini-css-extract-plugin
export default {"label":"SelectComponent_label__v7AnF","error-text":"SelectComponent_error-text__plDt5"};